import APICaller from '../library/APICaller'

const NoticeServices = {
  /**
   * 공지 리스트
   * @param  {Number} params.pageNo
   * @param  {Number} params.size
   * @param  {String} params.search
   * @return {Promise}
   */
  getNotices ({ category, pageNo, size, searchText }) {
    return APICaller.get('/api/v1/notices', {
      category: category,
      'pagingDTO.pageNo': pageNo,
      'pagingDTO.size': size,
      searchText: searchText
    })
  },
  /**
   * 공지 등록
   * @param  {String} params.contents
   * @param  {String} params.fileId
   * @param  {String} params.tenantCode
   * @param  {String} params.title
   * @return {Promise}
   */
  insertNotices ({ content, fileId, tenantCode, title }) {
    return APICaller.post('/api/v1/notices', {
      content, fileId, tenantCode, title
    })
  },
  /**
   * 노출 여부
   * @param  {String} id
   * @return {Promise}
   */
  updateVisible (id) {
    return APICaller.put(`/api/v1/notices/visible/${id}`)
  },
  /**
   * 공지 상세
   * @param  {String} id
   * @return {Promise}
   */
  getNoticeWithId (id) {
    return APICaller.get(`/api/v1/notices/${id}`, {
      id
    })
  },
  /**
   * 공지 수정
   * @param  {String} id
   * @param  {String} params.contents
   * @param  {String} params.fileId
   * @param  {String} params.tenantCode
   * @param  {String} params.title
   * @return {Promise}
   */
  putNoticeWithId (id, { content, fileId, tenantCode, title, visible }) {
    return APICaller.put(`/api/v1/notices/${id}`, {
      content, fileId, tenantCode, title, id, visible
    })
  },
  /**
   * 공지 삭제
   * @param  {String} id
   * @return {Promise}
   */
  deleteNoticeWithId (id) {
    return APICaller.delete(`/api/v1/notices/${id}`, {
      id
    })
  },
  /**
   * 공지 파일 삭제
   * @param  {String} id
   * @return {Promise}
   */
  deleteNoticeFilesWithId (id) {
    return APICaller.delete(`/api/v1/notices/files/${id}`, {
      id
    })
  }
}

export default NoticeServices



// WEBPACK FOOTER //
// ./src/services/NoticeServices.js